import { defineComponent as _defineComponent } from 'vue'
import {
        computed, toRefs, unref,
    } from 'vue';
    import { AlertBlock, IconBase } from '@shared/ui';
    import { asyncSvgLoader } from '@shared/lib';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import blackJetFlightNumbers from '../config/blackJetFlightNumbers';
    import star from './images/star.svg';

    interface IBlackJetRouteInfoProps {
        flightNumber: string;
        visibleTooltip?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BlackJetRouteInfo',
  props: {
    flightNumber: null,
    visibleTooltip: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { flightNumber: string, visibleTooltip: boolean }

    

    const starIcon = asyncSvgLoader(star);

    const { flightNumber } = toRefs(props);

    const isBlackJetFlight = computed(() => blackJetFlightNumbers.includes(unref(flightNumber)));

return { __sfc: true,props, starIcon, flightNumber, isBlackJetFlight, AlertBlock, IconBase, HintTooltip }
}

})